// Angular
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Angular Material
import { MatDialog } from '@angular/material/dialog';

// localforage
import * as localforage from 'localforage';

// services
import { ApiService } from '@app/services/api/api.service';

// components
import { CloseOpenHouseDialogComponent } from '@app/components/close-open-house-dialog/close-open-house-dialog.component';
import { ConfirmLogoutComponent } from '@app/components/confirm-logout/confirm-logout.component';
import { GoToAdminDashboardComponent } from '@app/components/go-to-admin-dashboard/go-to-admin-dashboard.component';

@Component({
  selector: 'oh-admin-settings',
  templateUrl: './admin-settings.component.html',
  styleUrls: ['./admin-settings.component.scss'],
})
export class AdminSettingsComponent implements OnInit {
  public openHouse: any;
  public pendingSurveySubmissions: any;
  public pendingFeedbackSubmissions: any;

  constructor(private router: Router, private dialog: MatDialog, private apiService: ApiService) {}

  async ngOnInit() {
    await this.getPendingSubmissions();
    this.openHouse = await localforage.getItem('oh-selected-open-house');
  }

  private async getPendingSubmissions() {
    try {
      this.pendingSurveySubmissions = await localforage.getItem('oh-survey-submissions');
      this.pendingFeedbackSubmissions = await localforage.getItem('oh-feedback-submissions');
    } catch (error) {
      console.log(error);
    }
  }

  public async endOpenHouse() {
    this.dialog.open(CloseOpenHouseDialogComponent, {
      width: '450px',
    });
  }

  public goToAdminDashboard(){
    this.dialog.open(GoToAdminDashboardComponent, {
      width: '450px',
    });
  }


  public submitFeedback() {
    this.router.navigate([], { queryParams: { drawer: 'admin-feedback' } });
  }

  public async logout() {
    this.dialog.open(ConfirmLogoutComponent, { width: '450px' });
  }
}
